var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueWaveMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 24,
    viewBox: "0 0 348 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.6576L13.3172 6.32881L25.7089 2L38.0634 6.32881L50.4179 10.6576",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4179 10.6576L62.7724 6.32881L75.1269 2L87.4813 6.32881L99.8358 10.6576",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8358 10.6576L112.19 6.32881L124.545 2L136.937 6.32881L149.291 10.6576",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.291 10.6576L161.645 6.32881L174 2L186.354 6.32881L198.709 10.6576",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M198.709 10.6576L211.063 6.32881L223.418 2L235.772 6.32881L248.127 10.6576",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M248.127 10.6576L260.481 6.32881L272.873 2L285.228 6.32881L297.582 10.6576",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M297.582 10.6576L309.937 6.32881L322.291 2L334.645 6.32881L347 10.6576",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 21.3152L13.3172 16.9864L25.7089 12.6576L38.0634 16.9864L50.4179 21.3152",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4179 21.3152L62.7724 16.9864L75.1269 12.6576L87.4813 16.9864L99.8358 21.3152",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8358 21.3152L112.19 16.9864L124.545 12.6576L136.937 16.9864L149.291 21.3152",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M149.291 21.3152L161.645 16.9864L174 12.6576L186.354 16.9864L198.709 21.3152",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M198.709 21.3152L211.063 16.9864L223.418 12.6576L235.772 16.9864L248.127 21.3152",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M248.127 21.3152L260.481 16.9864L272.873 12.6576L285.228 16.9864L297.582 21.3152",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M297.582 21.3152L309.937 16.9864L322.291 12.6576L334.645 16.9864L347 21.3152",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueWaveMobile);
export default __webpack_public_path__ + "static/media/blue-wave-mobile.5cbfe9c1a4e4fc2ecab4093190c47d5e.svg";
export { ForwardRef as ReactComponent };